import {DataTypeSubformProps} from "../DataTypeSubformProps";

export default function FolderSubform(props: DataTypeSubformProps) {
    return null;
}
